import styled from '../../../theme/styled-with-theme';

export const ErrorMessage = styled('div')<{
  visible: boolean;
  variant?: string;
}>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.textInputInvalid};
  max-height: ${({ visible }) => (visible ? '24px' : '0')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  margin-bottom: ${({ visible }) => (visible ? '16px' : '0')};
  -webkit-transition:
    max-height 0.3s,
    opacity 0.3s,
    padding 0.3s,
    margin-bottom 0.3s;
  -moz-transition:
    max-height 0.3s,
    opacity 0.3s,
    padding 0.3s,
    margin-bottom 0.3s;
  -ms-transition:
    max-height 0.3s,
    opacity 0.3s,
    padding 0.3s,
    margin-bottom 0.3s;
  -o-transition:
    max-height 0.3s,
    opacity 0.3s,
    padding 0.3s,
    margin-bottom 0.3s;
  transition:
    max-height 0.3s,
    opacity 0.3s,
    padding 0.3s,
    margin-bottom 0.3s;
  overflow: hidden;

  ${({ variant }) => {
    switch (variant) {
      case 'filterbar':
        return `
          display: none;
        `;

      default:
        return ``;
    }
  }}
`;

export const IconWrapper = styled('div')`
  margin-left: 16px;
  margin-right: 8px;
  height: 100%;
  display: flex;
`;
